var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { startTour } from '@/tours/tour-runner';
import { projectCreationTourSteps } from '@/tours/project-creation-tour';
import { dashboardTourSteps } from '@/tours/dashboard-tour';
import { estimatedCostListTourSteps } from '@/tours/estimated-cost-list-tour';
import { estimatedCostFormTourSteps } from '@/tours/estimated-cost-form-tour';
var tours = {
    'project-creation': { tourId: 'project-creation', steps: projectCreationTourSteps },
    dashboard: { tourId: 'dashboard', steps: dashboardTourSteps },
    'estimated-cost-list': { tourId: 'estimated-cost-list', steps: estimatedCostListTourSteps },
    'estimated-cost-form': { tourId: 'estimated-cost-form', steps: estimatedCostFormTourSteps }
};
/**
 * ツアーの最初のステップ要素が描画されて寸法を持つまで待機する。
 * Driver.js は起動時に getBoundingClientRect() でスポットライト座標を計算するため、
 * 要素が DOM にあってもゼロ寸法のうちに startTour するとスポットライトがビューポート中央になってしまう。
 * rAF でポーリングし、幅・高さが取れた時点で resolve する。
 */
function waitForElementReady(selector, maxWaitMs) {
    if (maxWaitMs === void 0) { maxWaitMs = 3000; }
    return new Promise(function (resolve) {
        var deadline = Date.now() + maxWaitMs;
        var check = function () {
            var el = document.querySelector(selector);
            if (el) {
                var rect = el.getBoundingClientRect();
                if (rect.width > 0 && rect.height > 0) {
                    resolve();
                    return;
                }
            }
            if (Date.now() < deadline) {
                requestAnimationFrame(check);
            }
            else {
                // タイムアウトしても起動は試みる
                resolve();
            }
        };
        check();
    });
}
export default (function (_a) {
    var _b;
    var app = _a.app, store = _a.store;
    var tryStart = function () { return __awaiter(void 0, void 0, void 0, function () {
        var tourId, firstElement;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    // 二重起動防止（クロージャ変数ではなく Vuex で管理）
                    if (store.getters['product-tour/isRunning'])
                        return [2 /*return*/];
                    tourId = (_a = app.router) === null || _a === void 0 ? void 0 : _a.currentRoute.query.tour;
                    if (!tourId || typeof tourId !== 'string' || !tours[tourId])
                        return [2 /*return*/];
                    store.dispatch('product-tour/setRunning', true);
                    firstElement = (_b = tours[tourId].steps[0]) === null || _b === void 0 ? void 0 : _b.element;
                    if (!(typeof firstElement === 'string')) return [3 /*break*/, 2];
                    return [4 /*yield*/, waitForElementReady(firstElement)];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2:
                    startTour(__assign(__assign({}, tours[tourId]), { callbacks: {
                            onStart: function () { return store.dispatch('product-tour/setActiveTourId', tourId); },
                            onStepChange: function (index) { return store.dispatch('product-tour/setCurrentStepIndex', index); },
                            onEnd: function () {
                                store.dispatch('product-tour/setRunning', false);
                                store.dispatch('product-tour/setActiveTourId', null);
                                store.dispatch('product-tour/setCurrentStepIndex', 0);
                            }
                        } }));
                    return [2 /*return*/];
            }
        });
    }); };
    // Vue Router のナビゲーション完了後、Vue の描画サイクル終了を待ってからツアー起動判定。
    // 従来の setTimeout(150ms) より正確に DOM 更新完了を検知できる。
    (_b = app.router) === null || _b === void 0 ? void 0 : _b.afterEach(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Vue.nextTick()];
                case 1:
                    _a.sent();
                    tryStart();
                    return [2 /*return*/];
            }
        });
    }); });
});
